import React from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import optaLogo from "../../assets/images/logo.svg";
import "./style.css";
const CommonBackdrop = ({ showBackdrop }) => {
  return showBackdrop ? (
    <div className="backdrop">
      <img alt="logo" src={optaLogo} />
      <ProgressSpinner animationDuration=".5s" strokeWidth="3" />
    </div>
  ) : null;
};

export default CommonBackdrop;
